// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.accessibility-icon {
  width: max-content;
  height: max-content;
  --padding-end: 0;
  --padding-start: 0;
  min-height: auto;
  --background: white;
  position: absolute;
  left: 1.5%;
  bottom: 1.5%;
  border: 1px solid var(--ion-color-black);
  border-radius: 50%;
}
.accessibility-icon ion-icon {
  background: white;
  border-radius: 50%;
  padding: 10px;
  font-size: 19px;
  color: var(--ion-color-black);
}`, "",{"version":3,"sources":["webpack://./src/app/app.component.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,UAAA;EACA,YAAA;EACA,wCAAA;EACA,kBAAA;AACF;AAAE;EACE,iBAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,6BAAA;AAEJ","sourcesContent":[".accessibility-icon{\n  width: max-content;\n  height: max-content;\n  --padding-end: 0;\n  --padding-start: 0;\n  min-height: auto;\n  --background: white;\n  position: absolute;\n  left: 1.5%;\n  bottom: 1.5%;\n  border: 1px solid var(--ion-color-black);\n  border-radius: 50%;\n  ion-icon {\n    background: white;\n    border-radius: 50%;\n    padding: 10px;\n    font-size: 19px;\n    color: var(--ion-color-black);\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
